import { Award, Shield, Star, Clock } from "lucide-react";

const CredentialsBadges = () => {
  const badges = [
    {
      icon: Shield,
      title: "CNO Registered",
      subtitle: "College of Nurses of Ontario",
      color: "bg-blue-500/10 text-blue-600",
    },
    {
      icon: Award,
      title: "ACLS Instructor",
      subtitle: "Certification Instructor",
      color: "bg-red-500/10 text-red-600",
    },
    {
      icon: Clock,
      title: "35+ Years",
      subtitle: "Clinical Experience",
      color: "bg-primary/10 text-primary",
    },
    {
      icon: Star,
      title: "100+ Reviews",
      subtitle: "5-Star Rating",
      color: "bg-accent/10 text-accent",
    },
  ];

  return (
    <div className="bg-muted/50 border-y border-border py-4">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="flex items-center gap-3"
              data-testid={`credential-badge-${index}`}
            >
              <div className={`p-2 rounded-lg ${badge.color}`}>
                <badge.icon className="w-5 h-5" />
              </div>
              <div>
                <p className="font-semibold text-sm">{badge.title}</p>
                <p className="text-xs text-muted-foreground">{badge.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CredentialsBadges;
